// The territories of the agency, by which its yearly goals are set
// (server/crm/crmGoalsApi.js). The departments of the companies are written
// many ways (« MARTINIQUE », « Martinique », « REUNION »): `territoryOf`
// finds theirs; a company elsewhere has none.
export const AGENCY_TERRITORIES = ['Guadeloupe', 'La Réunion', 'Martinique', 'Saint-Martin'];

const plain = (value) =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toUpperCase();

// Saint-Martin is a postcode of Guadeloupe's department (97150).
const SAINT_MARTIN_POSTCODE = '97150';

export const territoryOf = (company) => {
  const department = plain(company?.department);
  const postcode = String(company?.address?.postcode ?? company?.location?.postcode ?? '');
  // « MARTINIQUE » holds « MARTIN »: Saint-Martin is named in full.
  if (/\b(SAINT|ST)[- ]MARTIN\b/.test(department) || postcode === SAINT_MARTIN_POSTCODE) return 'Saint-Martin';
  if (department.includes('MARTINIQUE')) return 'Martinique';
  if (department.includes('GUADELOUPE')) return 'Guadeloupe';
  if (department.includes('REUNION')) return 'La Réunion';
  return null;
};
